export default `query cart($cartId: String!) {
    cart(cart_id:$cartId) {
      id
      raw_id
      email
      is_virtual
      applied_coupons {
        code
      }
      prices {
        subtotal_excluding_tax {
          value
        },
        subtotal_including_tax {
          value
        },
        applied_taxes {
          amount {
            value
          },
          label
        }
        discounts {
          amount {
            value
          },
          label
        }
        grand_total {
          value
        }
      }
      items {
        uid
        product {
          uid
          __typename
          sku
          bundle_name
          startup_cost
          attribute_set_id
          fulfillment_pipeline
          zuora_completed
          name
          stock_status
          only_x_left_in_stock
          rating_summary
          tipo_abbonamento
          tipo_rinnovo
          is_trial
          thumbnail {
            url
            position
            disabled
            label
          }
          url_key
          url_rewrites {
            url
          }
          price_range {
            maximum_price {
              final_price {
                currency
                value
              }
              regular_price {
                currency
                value
              }
            }
            minimum_price {
              final_price {
                currency
                value
              }
              regular_price {
                currency
                value
              }
            }
          }
          categories {
            uid
            name
            url_suffix
            url_path
            breadcrumbs {
              category_name,
              category_url_path
            }
          }
          review_count
          reviews {
            items {
              average_rating
              ratings_breakdown {
                name
                value
              }
            }
          }
          ...on ConfigurableProduct{
          configurable_options{
            attribute_code
            attribute_uid
            label
            uid
            values{
                value_index
                label
                uid
            }
          }
          variants{
            product{
                sku
                software_module
                tipo_abbonamento
            }
          }
          }
        }
        prices {
          row_total {
            value
          }
          row_total_including_tax {
            value
          }
          total_item_discount {
            value
          }
        }
        quantity
        ... on ConfigurableCartItem {
          configurable_options {
            configurable_product_option_uid
            option_label
            configurable_product_option_value_uid
            option_label
            value_label
          }
          configured_variant {
            sku
            name
            tipo_consegna
            natura
            thumbnail {
              url
            }
          }
        }
        ... on BundleCartItem {
           
        product{
          type_id
          tipo_abbonamento
          bundle_name
          ... on BundleProduct{
            items{
            options{
              product{
                sku
                ... on ConfigurableProduct{
            variants{
            product{
              tipo_abbonamento
              tipo_consegna
              }
            }
            options{
             uid
             title
            }
          }
              }
            }
          }
          }
          
          
          
        }
          bundle_options {
            uid
            label
            type
            values {
              id
              sku
              label
              price
              quantity
               configurable_options{
                value
                label
                code
            }
            }
          }
        }
      }
      total_quantity
      shipping_addresses {
        firstname
        lastname
        street
        city
        company
        region {
          code
          region_id
          label
        }
        postcode
        telephone
        country {
          code
          label
        }
        selected_shipping_method {
          carrier_code
          carrier_title
          method_code
          method_title
          amount {
            value
            currency
          }
        }
      }
      billing_address {
        firstname
        lastname
        street
        city
        company
        region {
          code
          region_id
          label
        }
        postcode
        telephone
        country {
          code
          label
        }
      }
    }
  }
`